import { render, staticRenderFns } from "./CompanyHistory.vue?vue&type=template&id=2686045a&scoped=true&"
import script from "./CompanyHistory.vue?vue&type=script&lang=js&"
export * from "./CompanyHistory.vue?vue&type=script&lang=js&"
import style0 from "./CompanyHistory.vue?vue&type=style&index=0&id=2686045a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2686045a",
  null
  
)

export default component.exports